module.exports = __webpack_public_path__ + "static/img/role.2bb82db.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/oo/role.png
// module id = iIbn
// module chunks = 7